export default __webpack_public_path__ + "static/media/circle-cross-4.baf01d1d.svg";